import { render, staticRenderFns } from "./ItemDetailsLink.vue?vue&type=template&id=d33c56bc&scoped=true"
import script from "./ItemDetailsLink.vue?vue&type=script&lang=ts"
export * from "./ItemDetailsLink.vue?vue&type=script&lang=ts"
import style0 from "./ItemDetailsLink.vue?vue&type=style&index=0&id=d33c56bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d33c56bc",
  null
  
)

export default component.exports